import { Collapse, type CollapseProps } from "antd";
import i18n from "i18next";
import type { FC } from "react";

import type { TerminalImportLogEntity } from "src/app/features/TerminalImportLog/types/TerminalImportLogEntity";
import { displayDateTimeValue } from "../../../../../components/Table/components/PropertyTable/transformations/cellTransformations";

type TerminalImportLogMessageCardProps = {
    log?: TerminalImportLogEntity;
};

export const TerminalImportLogMessageCard: FC<TerminalImportLogMessageCardProps> = ({ log }) => {
    const items: CollapseProps["items"] = [
        {
            key: "TerminalImportLogItemMessageCard",
            label: i18n.t("terminalImportLogList.messageCardTitle"),
            children: (
                <p className="aevi-text">
                    <span className="aevi-text-bold">{i18n.t("terminalImportLogList.fileName")}:</span> {log?.fileName ?? "N/A"}
                    <br />
                    <span className="aevi-text-bold">{i18n.t("terminalImportLogList.importDate")}:</span>{" "}
                    {log?.importDate ? displayDateTimeValue(log?.importDate) : "N/A"}
                    <br />
                    <span className="aevi-text-bold">{i18n.t("terminalImportLogList.importSuccessful")}:</span>{" "}
                    {log?.importSuccessful === true ? i18n.t("terminalImportLogList.successful") : i18n.t("terminalImportLogList.failed")}
                    <br />
                    <span className="aevi-text-bold">{i18n.t("terminalImportLogList.totalRecords")}:</span> {log?.totalRecords ?? "N/A"}
                    <br />
                    <span className="aevi-text-bold">{i18n.t("terminalImportLogList.importedRecords")}:</span>{" "}
                    {log?.importedRecords ?? "N/A"}
                </p>
            ),
        },
    ];

    return (
        <div style={{ marginBottom: 25 }}>
            <Collapse items={items} defaultActiveKey={["TerminalImportLogItemMessageCard"]} />
        </div>
    );
};
